export default __webpack_public_path__ + "static/34-7d8061c9532a1528eb5c23ec7ffaed91.jpg";